import { axiosInstance, API_END_POINT } from '@app-store'

interface PropsType {
  payload: {
    searchDto: {
      fields: never[]
      search_criteria: {
        search_key: string
        search_value: string[] | number[]
        operator: string
      }[]
    }
    fieldsToInclude: string[]
    ColumnNames: string[]
  }
  fileType: string
  TenantId?: number
  sortDirection?: string
  sortKey?: string
}

const fetchDataForExport = async ({
  payload,
  fileType,
  TenantId,
  sortDirection,
  sortKey,
}: PropsType) => {
  const baseUrl = `${API_END_POINT.TEMPLATE}/v1/exportData/communicationLogs/advance/${fileType}`

  const url =
    sortDirection !== 'disabled'
      ? `${baseUrl}?sort=${sortKey},${sortDirection}`
      : baseUrl

  return await axiosInstance.post(url, {
    headers: {
      'X-TenantId': TenantId,
    },
    ...payload,
  })
}

const fetchDataForExportClient = async ({ payload, fileType }: PropsType) => {
  return await axiosInstance.post(
    `${API_END_POINT.CORE}export/client/advance/${fileType}`,
    {
      ...payload,
    }
  )
}

const fetchDataForExportProduct = async ({ payload, fileType }: PropsType) => {
  return await axiosInstance.post(
    `${API_END_POINT.CORE}export/product/advance/${fileType}`,
    {
      ...payload,
    }
  )
}

const fetchFilePreviewUrlUsingFileName = async (fileName: string) => {
  const response = await axiosInstance.get(
    `${API_END_POINT.CORE}v1/files/generate-download-url?fileName=${fileName}`
  )
  return response
}

export {
  fetchDataForExport,
  fetchDataForExportClient,
  fetchDataForExportProduct,
  fetchFilePreviewUrlUsingFileName
}
